import React, { useCallback, useState, useEffect } from 'react';

import type FlightListDomain from '@this/domain/flight/flight_list'; // component定義とdomain名が被っている。classのListは消していきたくない？
import type FlightSliceCandidate from '@this/domain/flight/flight_slice_candidate';
import type SelectRepository from '@this/domain/select_repository';
import type SelectStore from '@this/src/domain/select_store';
import { reportError } from '@this/lib/bugsnag';
import { useAITTheme } from '@this/shared/ui/theme';
import FlightBox from '../../flight_box';

interface FlightListProps {
  flights: FlightListDomain;
  type: number;
  repository: SelectRepository;
  store: SelectStore;
  onChange: () => void;
}

const FlightList = ({ flights, type, repository, store, onChange }: FlightListProps) => {
  const { theme } = useAITTheme();
  const [hasError, setHasError] = useState(false);

  const handleSelect = useCallback(
    (f: FlightSliceCandidate) => {
      try {
        onChange();
        const flightId = flights.corporatePublishedFareParallelDisplayEnabled
          ? f.cheapestFlight().id
          : f.list[0].id;
        flights.selectWithAnimation(flightId);
      } catch (error) {
        reportError(error);
        setHasError(true);
      }
    },
    [onChange, flights]
  );

  const handleReload = useCallback(() => {
    try {
      repository.reloadFlights();
      setHasError(false);
    } catch (error) {
      reportError(error);
      setHasError(true);
    }
  }, [repository]);

  const flightCandidates = flights.flightCandidates(type, true);
  const isDomestic = store.result.isDomesticAirResult();
  const currentCandidateKey = flights.currentCandidateKey(type);
  const minPrice = flightCandidates.length
    ? Math.min(...flightCandidates.map(candidate => candidate.cheapestFlight().price))
    : null;

  useEffect(() => {
    setHasError(false);
  }, [flights, type]);

  if (hasError) {
    return (
      <div className="select-transport-list">
        <div className="center" style={{ padding: '40px 20px', textAlign: 'center' }}>
          <p>エラーが発生しました。</p>
          <button type="button" onClick={() => setHasError(false)} style={{ marginTop: '10px' }}>
            再試行
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="select-transport-list">
      {flightCandidates.map(f => (
        <FlightBox
          key={f.key}
          flight={f}
          inList
          selected={currentCandidateKey === f.key}
          handleSelect={handleSelect}
          flightIndex={type}
          tab={type}
          isDomestic={isDomestic}
          showFareTypeBadges={flights.corporatePublishedFareParallelDisplayEnabled}
          isLowest={minPrice !== null && f.isLowest(minPrice)}
        />
      ))}
      <div className="center" style={{ marginTop: '20px' }}>
        ご希望の便が表示されませんか？
        <br />
        <button
          type="button"
          style={{
            marginTop: '20px',
            backgroundColor: theme.linkColor,
            borderColor: theme.linkColor
          }}
          onClick={handleReload}
        >
          現在の条件で再検索
        </button>
      </div>
    </div>
  );
};

export default FlightList;
